<div class="gl-page">
  <yds-button-back
    text="Ga terug 'Loonjournaal voor grootboeksysteem - Loonjournaal selecteren'"
    (back)="onBack()"
  />

  <div class="gl-page__header">
    <h1 class="gl-page__title">Downloadlijst vorige grootboek exporten</h1>
  </div>

  @if (downloadError()) {
    <span class="dgl-error" role="alert">{{ downloadError() }}</span>
  }

  @if (isLoading()) {
    <yds-card>
      <div class="gl-list-state">
        <yds-spinner [label]="'Exporten laden...'" />
      </div>
    </yds-card>
  } @else if (loadError()) {
    <yds-empty-states [variant]="'error'" [message]="loadError() ?? ''" />
  } @else if (exports().length === 0) {
    <yds-empty-states [message]="'Er zijn nog geen exporten'" />
  } @else {
    <yds-card>
      <div class="gl-list-table">
        <yds-table
          [embedded]="true"
          [showPaginationFooter]="true"
          [columns]="tableColumns"
          [items]="tableItems()"
          [zebra]="true"
          [dottedColumns]="true"
          [clickable]="true"
          (rowClick)="onRowClick($event)"
        >
          <ng-template ydsTableCell="status" let-item="item">
            <yds-badge [type]="'label'" [variant]="statusVariant(item.exportStatus)">
              {{ statusLabel(item.exportStatus) }}
            </yds-badge>
            @if (item.errorMessage) {
              <span class="dgl-status-error">{{ item.errorMessage }}</span>
            }
          </ng-template>

          <ng-template ydsTableCell="download" let-item="item">
            @if (isFileApiSend(item.sendTo)) {
              <span>Gestuurd via File-API</span>
            } @else if (isDone(item.exportStatus)) {
              <a href="#" (click)="onDownload($event, item)">Download</a>
              @if (downloadingId() === item.id) {
                <yds-spinner size="sm" [label]="'Export downloaden...'" />
              }
            }
          </ng-template>

          <yds-pagination
            pagination
            [(pageIndex)]="pageIndex"
            [pageSize]="pageSize"
            [totalItems]="exports().length"
          />
        </yds-table>
      </div>
    </yds-card>
  }
</div>
